import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProfileHeaderProps {
  name: string;
  email: string;
  avatar?: string;
  isPremium?: boolean;
  onClick?: () => void;
}

/**
 * iOS 风格的个人资料头部组件
 */
export const ProfileHeader: React.FC<ProfileHeaderProps> = ({
  name,
  email,
  avatar,
  isPremium = false,
  onClick,
}) => {
  const { t } = useTranslation(['v3/common']);
  return (
    <div
      className={`p-4 flex items-center ${onClick ? 'cursor-pointer active:bg-ios-gray6 dark:active:bg-ios-dark-gray5' : ''}`}
      onClick={onClick}
    >
      {/* 头像 */}
      <div className="w-16 h-16 rounded-full bg-ios-blue dark:bg-ios-dark-blue flex items-center justify-center text-white text-2xl font-semibold overflow-hidden">
        {avatar ? (
          <img src={avatar} alt={name} className="w-full h-full object-cover" />
        ) : (
          name.charAt(0)
        )}
      </div>

      {/* 用户信息 */}
      <div className="ml-4 flex-1">
        <div className="flex items-center">
          <h2 className="text-ios-title3 font-semibold">{name}</h2>
          {isPremium && (
            <span className="ml-2 px-2 py-0.5 text-xs font-semibold uppercase rounded-full bg-ios-teal text-white">
              {t('v3/common:subscription.plus')}
            </span>
          )}
        </div>
        <p className="text-ios-subhead text-ios-gray dark:text-ios-dark-gray">{email}</p>
      </div>

      {/* 右侧箭头 */}
      {onClick && (
        <svg className="w-5 h-5 text-ios-gray3 dark:text-ios-dark-gray3" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )}
    </div>
  );
};
